module.exports = __webpack_public_path__ + "static/media/Kelli Gemmer headshot_1712049565069.669d49fd.jpg";